import React from 'react';
import { FadeIn } from './FadeIn';
export function PainSection() {
  const pains = [{
    icon: '📅',
    text: 'Agenda desorganizada porque anotás los turnos en cualquier papel o en el chat de WhatsApp'
  }, {
    icon: '❌',
    text: 'Clientas que cancelan a último momento y ese hueco queda vacío sin posibilidad de llenarlo'
  }, {
    icon: '💸',
    text: 'Sin política de señas porque no sabés cómo pedirlas sin que la clienta se ofenda'
  }, {
    icon: '💬',
    text: 'Respondés el mismo WhatsApp 10 veces por semana porque no tenés un texto listo para cada situación'
  }, {
    icon: '📊',
    text: 'Fin de mes y no sabés exactamente cuánto ganaste ni cuánto gastaste en insumos'
  }, {
    icon: '📱',
    text: 'Redes que no convierten porque no sabés qué publicar para que te escriban pidiendo turno'
  }, {
    icon: '⚖️',
    text: 'Sin documentos legales que te protejan ante clientas conflictivas o reclamos injustos'
  }];
  return <section className="py-14 px-4 max-w-4xl mx-auto pt-[5px] pb-[5px] space-y-[0px]" data-id="element-201">
      <FadeIn data-id="element-202">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-6" data-id="element-203">
          ¿Cuántos domingos más vas a perder así?
        </h2>

        <div className="text-lg md:text-xl text-gray-300 text-center mb-10 space-y-4 max-w-3xl mx-auto" data-id="element-204">
          <p data-id="element-205">
            Amás lo que hacés. Elegiste ser manicurista porque te apasiona el
            detalle, el vínculo con la clienta, ver una mano transformada en 90
            minutos.
          </p>
          <p data-id="element-206">
            Pero nadie te dijo que ibas a pasar los domingos buscando cómo
            responderle a la clienta que canceló sin avisar, armando fichas
            técnicas desde cero o calculando si el mes te alcanza o no. Que ibas
            a responder el mismo WhatsApp 10 veces por semana. Que llenar la
            agenda iba a sentirse como un trabajo aparte del que ya hacés con
            tus manos.
          </p>
          <p className="font-bold text-white text-2xl mt-8" data-id="element-207">
            No es falta de vocación.{' '}
            <span className="text-red-400" data-id="element-208">Es falta de un sistema.</span>
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-209">
        <div className="bg-red-950/20 border border-red-900/50 rounded-2xl p-6 md:p-10 shadow-lg" data-id="element-210">
          <p className="text-xl font-bold text-gray-200 mb-6" data-id="element-211">
            Lo que vive el 80% de las manicuristas independientes:
          </p>
          <ul className="space-y-6" data-id="element-212">
            {pains.map((pain, index) => <li key={index} className="flex gap-4 items-start" data-id="element-213">
                <span className="text-2xl shrink-0 mt-0.5" data-id="element-214">{pain.icon}</span>
                <span className="text-gray-300 text-lg" data-id="element-215">{pain.text}</span>
              </li>)}
          </ul>
          <p className="text-center text-gray-400 mt-8 font-medium" data-id="element-216">
            Domingo agotada. El lunes, el mismo ciclo.
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-217">
        <div className="text-center mt-14" data-id="element-218">
          <h3 className="text-3xl md:text-4xl font-bold text-pink-400" data-id="element-219">
            ¿Y si este fuera el último domingo que pasaste así?
          </h3>
        </div>
      </FadeIn>
    </section>;
}